module.exports = __webpack_public_path__ + "pc/static/img/weibo.ce4e2ab5.png";